import React from 'react';

import { Inline } from '@styleseat/ui';
import { HeaderText } from '../../../ui';

type TitleProps = {
  modeText: string;
  headerLevel?: '1' | 1 | '2' | 2 | '3' | 3 | '4' | 4;
  showingExtend?: boolean;
};
const Title: React.FC<TitleProps> = ({
  modeText,
  headerLevel = 3,
  showingExtend = false,
}) => (
  <Inline space={4} paddingTop={24} paddingBottom={showingExtend ? 0 : 8}>
    <HeaderText
      level={headerLevel}
      style={{ fontWeight: '300' }}
    >
      {modeText}
    </HeaderText>
    <HeaderText
      level={headerLevel}
    >
      SEARCH BOOST
    </HeaderText>
  </Inline>
);

export default Title;
